import React, { useState } from 'react';

// Styles & Assets
import styles from './PatientGenerateQRButton.module.css';
import { MdQrCode } from 'react-icons/md';

// Hooks
import usePatientStore from '../../../stores/patient-store';
import { useTranslation } from 'react-i18next';

// Components
import Modal from '../../UI/Modal/Modal';
import PatientQRDialog from '../PatientQRDialog/PatientQRDialog';

// Interfaces
interface Props {
    readOnly: boolean
}


const PatientGenerateQRButton: React.FC<Props> = ({ readOnly }) => {

    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false)

    const patient = usePatientStore(state => state.patient);


    return (
        <>
            <button
                disabled={readOnly || !patient?.study}
                onClick={() => setShowModal(true)}
                className={`button ${styles.buttonToolbar} ${styles.generateQRButton}`}
            >
                <span>{t('generate_QR')} </span> <MdQrCode />
            </button>
            <Modal show={showModal} setShowModal={setShowModal}>
                <PatientQRDialog
                    patient={patient ?? undefined}
                    setShowModal={setShowModal}
                />
            </Modal>
        </>
    );
};

export default PatientGenerateQRButton;